(function($) {
  $('.reference-slider').slick({
    autoplay: true,
    autoplaySpeed: 8000
  });
})(jQuery);
